import React from "react";
import { Typography, type SxProps, type Theme } from "@mui/material";
import { BRAND } from "../../constants/brand";

type PoweredByBrandProps = {
  sx?: SxProps<Theme>;
  /** Lighter text for dark/colored panels */
  light?: boolean;
};

/** Consistent company credit across login, landing, and shell. */
const PoweredByBrand: React.FC<PoweredByBrandProps> = ({ sx, light }) => (
  <Typography
    variant="caption"
    component="p"
    sx={{
      m: 0,
      textAlign: "center",
      letterSpacing: "0.02em",
      color: light ? "rgba(255,255,255,0.85)" : "text.secondary",
      ...sx,
    }}
  >
    {BRAND.poweredBy}
  </Typography>
);

export default PoweredByBrand;
